module.exports = __webpack_public_path__ + "img/shipo-icon-download.37644573.svg";